"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _getCurrentPriceColor = require("./getCurrentPriceColor");
Object.keys(_getCurrentPriceColor).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getCurrentPriceColor[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _getCurrentPriceColor[key];
    }
  });
});
//# sourceMappingURL=index.js.map